var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01494 2.18237C6.53244 2.18237 4.51494 4.19987 4.51494 6.68237V8.84987C4.51494 9.30737 4.31994 10.0049 4.08744 10.3949L3.22494 11.8274C2.69244 12.7124 3.05994 13.6949 4.03494 14.0249C7.26744 15.1049 10.7549 15.1049 13.9874 14.0249C14.8949 13.7249 15.2924 12.6524 14.7974 11.8274L13.9349 10.3949C13.7099 10.0049 13.5149 9.30737 13.5149 8.84987V6.68237C13.5149 4.20737 11.4899 2.18237 9.01494 2.18237Z",
    stroke: "#475B78",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4024 2.40008C10.1699 2.33258 9.92994 2.28008 9.68244 2.25008C8.96244 2.16008 8.27244 2.21258 7.62744 2.40008C7.84494 1.84508 8.38494 1.45508 9.01494 1.45508C9.64494 1.45508 10.1849 1.84508 10.4024 2.40008Z",
    stroke: "#475B78",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2649 14.295C11.2649 15.5325 10.2524 16.545 9.01489 16.545C8.39989 16.545 7.82989 16.29 7.42489 15.885C7.01989 15.48 6.76489 14.91 6.76489 14.295",
    stroke: "#475B78",
    strokeWidth: 1.125,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0f0ad03210fc61b577d5ed1e8854bfa9.svg";
export { ForwardRef as ReactComponent };